/* eslint-disable no-underscore-dangle */

/* eslint-disable class-methods-use-this */
import { loginScopes } from '@/msAuthConfig'
import { storage } from '@utils/storageHelpers'
import toast from 'react-hot-toast'

import { baseUrl } from '../constants'

// const log = Logger('AuthUtils')

const AuthStorageKeys = {
	SsoToken: 'sso_token', // was 'accessToken'
	SsoAccount: 'sso_account', // was 'account'
	AccessToken: 'access_token', // was 'token.token'
	RefreshToken: 'refresh_token',
	Role: 'role', // the user's role
}

export const loginUrl = `${baseUrl}/v1/authenticate/login`
export const renewUrl = `${baseUrl}/v1/authenticate/renew`

class AuthUtils {
	listeners: any[]

	constructor() {
		this.listeners = []
	}

	onSsoAuthChange(listener) {
		function handler({ key, newValue }) {
			if (key === null) {
				// storage was cleared
				listener(null)
			}
			if (key === AuthStorageKeys.SsoToken) {
				listener(newValue)
			}
		}

		this.listeners.push(listener)

		window.addEventListener('storage', handler)

		return {
			unsubscribe: () => {
				this.listeners = this.listeners.filter((l) => l !== listener)
				// window.removeEventListener('storage', handler)
			},
		}
	}

	_notifyAuthChange() {
		const token = this.getSsoToken()
		this.listeners.forEach((listener) => listener(token))
	}

	getSsoToken() {
		return localStorage.getItem(AuthStorageKeys.SsoToken)
	}

	setSsoToken(token) {
		localStorage.setItem(AuthStorageKeys.SsoToken, token)
	}

	getSsoAccount() {
		const account = localStorage.getItem(AuthStorageKeys.SsoAccount)
		if (account) {
			return JSON.parse(account)
		}
		return null
	}

	setSsoAccount(account) {
		localStorage.setItem(AuthStorageKeys.SsoAccount, JSON.stringify(account))
	}

	getAccessToken() {
		return localStorage.getItem(AuthStorageKeys.AccessToken)
	}

	setAccessToken(token) {
		localStorage.setItem(AuthStorageKeys.AccessToken, token)
	}

	getRefreshToken() {
		return localStorage.getItem(AuthStorageKeys.RefreshToken)
	}

	setRefreshToken(token) {
		localStorage.setItem(AuthStorageKeys.RefreshToken, token)
	}

	getRole() {
		return localStorage.getItem(AuthStorageKeys.Role)
	}

	setRole(value) {
		localStorage.setItem(AuthStorageKeys.Role, value)
	}

	getBepTokens() {
		if (!this.getAccessToken() || !this.getRefreshToken()) {
			return null
		}
		return {
			accessToken: this.getAccessToken(),
			refreshToken: this.getRefreshToken(),
			role: this.getRole(),
		}
	}

	clearBepTokens() {
		localStorage.removeItem(AuthStorageKeys.SsoAccount)
		localStorage.removeItem(AuthStorageKeys.SsoToken)
		localStorage.removeItem(AuthStorageKeys.RefreshToken)
		localStorage.removeItem(AuthStorageKeys.AccessToken)
		localStorage.removeItem(AuthStorageKeys.Role)
		this._notifyAuthChange()
	}

	logout() {
		storage.clear()
		this.clearBepTokens()
		if (localStorage.getItem('qa_auth_token')) {
			window.location.assign('/')
		} else {
			window.msalInstance.logoutRedirect({
				postLogoutRedirectUri: '/',
			})
		}
	}

	async ssoLogin() {
		try {
			const loginResponse = await window.msalInstance.loginPopup({
				...loginScopes,
				prompt: 'select_account',
			})
			this.setSsoToken(loginResponse.accessToken)
			this.setSsoAccount(loginResponse.account)
			this._notifyAuthChange()

			return loginResponse
		} catch (e) {
			// handle error
			toast.error(`Service Issue: We couldn't log you in. /n/n ${e?.message || ''}`)
			console.error(e)
			throw new Error(e)
		}
	}

	/**
	 * Login in the user to the BEP API and get the refresh token
	 */
	// async bepLogin() {
	// 	log.info('Logging into BEP')
	// 	if (!this.getSsoToken() || !this.getSsoAccount()) {
	// 		log.info('Tried getting BEP tokens without an SSO token')
	// 		window.location.assign('/login')
	// 	}
	// 	const ssoAccount = this.getSsoAccount()
	// 	let role = null

	// 	const firstName = ssoAccount.name.split(' ')[0]
	// 	const lastName = ssoAccount.name.split(' ')[1]
	// 	const email = ssoAccount.username

	// 	const request = {
	// 		email,
	// 		microsoftToken: this.getSsoToken(),
	// 		firstName,
	// 		lastName,
	// 	}

	// 	try {
	// 		// Call the /login endpoint to get the refresh token (24hr ttl)

	// 		const refreshTokenRes = await fetch(loginUrl, {
	// 			method: 'POST',
	// 			mode: 'cors',
	// 			headers: new Headers({ 'content-type': 'application/json' }),
	// 			body: JSON.stringify(request),
	// 		})
	// 		if (!refreshTokenRes.ok) {
	// 			if (refreshTokenRes.status === 401) {
	// 				// not authorized or no user found
	// 				log.info('User Not Added')
	// 				throw new ApiError(401, 'User Not Added')
	// 			}

	// 			// some other terrible error
	// 			const refreshTokenJson = await refreshTokenRes.json()
	// 			log.error('Error logging in: ', refreshTokenJson)

	// 			throw new Error(JSON.stringify(refreshTokenJson))
	// 		}

	// 		const refreshTokenJson = await refreshTokenRes.json()
	// 		this.setRefreshToken(refreshTokenJson.token)
	// 		if (refreshTokenJson.admin) {
	// 			role = 'admin'
	// 			this.setRole(role)
	// 		} else {
	// 			this.setRole('user')
	// 		}

	// 		return {
	// 			refreshToken: refreshTokenJson.token,
	// 			role,
	// 		}
	// 	} catch (error) {
	// 		if (error.message === 'Failed to fetch') window.location.assign('/503')
	// 		if (error.message === 'User Not Added') {
	// 			router.navigate('/403')
	// 		}
	// 		console.error('Error logging in: ', error)
	// 		log.error('Error logging in: ', error)
	// 		throw new Error(error)
	// 	}
	// }

	// async refreshBepToken() {
	// 	log.info('Refreshing BEP tokens')
	// 	if (!this.getRefreshToken()) {
	// 		throw new Error('No refresh_token found')
	// 	}
	// 	let role = null

	// 	const refreshToken = this.getRefreshToken()

	// 	try {
	// 		const headers = new Headers({
	// 			Authorization: `Bearer ${refreshToken}`,
	// 			'content-type': 'application/json',
	// 		})

	// 		const accessTokenRes = await fetch(renewUrl, {
	// 			method: 'POST',
	// 			mode: 'cors',
	// 			headers,
	// 		})
	// 		const accessTokenJson = await accessTokenRes.json()

	// 		if (!accessTokenRes.ok) {
	// 			if (accessTokenRes.status === 401) {
	// 				// not authorized or no user found
	// 				console.error('Error getting token: ', accessTokenRes)
	// 				throw new Error('User Not Added')
	// 			}
	// 			if (accessTokenRes.status === 440) {
	// 				// Refresh token expired
	// 				return {
	// 					success: false,
	// 					accessToken: undefined,
	// 					role: undefined,
	// 					message: 'Refresh token expired',
	// 				}
	// 			}
	// 			if (accessTokenJson.error.message === 'Login has expired. User needs to log in again.') {
	// 				// Refresh token expired
	// 				return {
	// 					success: false,
	// 					accessToken: undefined,
	// 					role: undefined,
	// 					message: 'Login expired',
	// 				}
	// 			}
	// 		}

	// 		this.setAccessToken(accessTokenJson.token)
	// 		if (accessTokenJson.admin) {
	// 			role = 'admin'
	// 			this.setRole(role)
	// 		} else {
	// 			this.setRole('user')
	// 		}

	// 		return {
	// 			success: true,
	// 			accessToken: accessTokenJson.token,
	// 			role,
	// 			message: '',
	// 		}
	// 	} catch (error) {
	// 		if (error.message === 'Failed to fetch') window.location.assign('/503')
	// 		if (error.message === 'User Not Added') {
	// 			router.navigate('/403')
	// 		}
	// 		console.error('Error refreshing tokens: ', error)
	// 		throw new Error(error)
	// 	}
	// }
}

export default new AuthUtils()
